import { useState } from "react"
import { useNavigate, useLocation } from "react-router"
import { useAdminStore } from "@/shared/hooks/use-admin-store"
import styles from "./login-page.module.css"

export function AdminLoginPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const { login, isLoading, error: storeError } = useAdminStore()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")

  const from = (location.state as { from?: string })?.from || "/admin/dashboard"

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")

    if (!email.trim() || !password.trim()) {
      setError("请输入邮箱和密码")
      return
    }

    const err = await login(email.trim(), password)
    if (err) {
      if (err.includes("Invalid login")) {
        setError("邮箱或密码错误")
      } else if (err.includes("没有管理员权限")) {
        setError("该账号没有管理员权限，请联系超级管理员")
      } else {
        setError(err)
      }
      return
    }

    navigate(from, { replace: true })
  }

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>🔵</div>
        <h1 className={styles.title}>蓝血精英 · 管理后台</h1>
        <p className={styles.subtitle}>请登录以继续</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="email">邮箱</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入管理员邮箱"
              autoComplete="email"
              required
            />
          </div>

          <div className={styles.field}>
            <label htmlFor="password">密码</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="输入密码"
              autoComplete="current-password"
              required
            />
          </div>

          {(error || storeError) && <p className={styles.error}>{error || storeError}</p>}

          <button type="submit" className={styles.submit} disabled={isLoading}>
            {isLoading ? "登录中..." : "登录"}
          </button>
        </form>
      </div>
    </div>
  )
}

export default AdminLoginPage
